/**
 * 병점역 셔틀 노선 하드코딩 데이터
 * ShuttleRouteDetail + ByeongjeomBoardingMode 공통 사용
 * 좌표 출처: src/data/shuttleStops.js (변경 시 함께 수정)
 */

import { SHUTTLE_STOPS } from './shuttle/stops.js'

// ── 좌표 상수 (shuttleStops.js 값 직접 참조) ─────────────────────────────────
const HUM_DROP = { lat: 37.21349,  lng: 126.978482 }  // campus-hum-exit (하차)
const HUM_PICK = { lat: 37.213019, lng: 126.978107 }  // campus-inmundae
const BYEONGJEOM = { lat: 37.207061, lng: 127.031807 } // byeongjeom-station
const CAMPUS_CENTER = { lat: 37.214146, lng: 126.978794 }
const BYEONGJEOM_OUTBOUND_MID = {
  lat: SHUTTLE_STOPS['campus-byeongjeom-hagyo'].lat,
  lng: SHUTTLE_STOPS['campus-byeongjeom-hagyo'].lng,
} // campus-byeongjeom-hagyo — 하교 승차 정류장, 경로 지오메트리 겸용

export { CAMPUS_CENTER }

// ── inbound 노선 (병점역 → 수원대) ─────────────────────────────────────────
export const BYEONGJEOM_ROUTES = [
  {
    id: 'byeongjeom_0830',
    label: '08:30',
    fullLabel: '병점역 08:30',
    time: '08:30',
    departureTime: '08:30',
    routeName: '병점역 → 수원대',
    startName: '병점역 후문',
    endName: '학생회관 사거리',
    durationText: '약 40분',
    durationSec: 40 * 60,
    direction: 'inbound',
    summary: '학생회관 사거리 도착',
    notice: '이 시간대는 병점역 후문에서 출발하여 학생회관 사거리에 도착합니다.',
    stops: [
      { id: 'byeongjeom-station', name: '병점역 후문',    type: 'start', lat: BYEONGJEOM.lat, lng: BYEONGJEOM.lng },
      { id: 'campus-sh',          name: '학생회관 사거리', type: 'end',   lat: 37.210081,     lng: 126.97701 },
    ],
    path: [
      BYEONGJEOM,
      { lat: 37.210081, lng: 126.97701 },
    ],
  },
  {
    id: 'byeongjeom_0840',
    label: '08:40',
    fullLabel: '병점역 08:40',
    time: '08:40',
    departureTime: '08:40',
    routeName: '병점역 → 수원대',
    startName: '병점역 후문',
    endName: '학생회관 사거리',
    durationText: '약 40분',
    durationSec: 40 * 60,
    direction: 'inbound',
    summary: '학생회관 사거리 도착',
    notice: '이 시간대는 병점역 후문에서 출발하여 학생회관 사거리에 도착합니다.',
    stops: [
      { id: 'byeongjeom-station', name: '병점역 후문',    type: 'start', lat: BYEONGJEOM.lat, lng: BYEONGJEOM.lng },
      { id: 'campus-sh',          name: '학생회관 사거리', type: 'end',   lat: 37.210081,     lng: 126.97701 },
    ],
    path: [
      BYEONGJEOM,
      { lat: 37.210081, lng: 126.97701 },
    ],
  },
  {
    id: 'byeongjeom_0850',
    label: '08:50',
    fullLabel: '병점역 08:50',
    time: '08:50',
    departureTime: '08:50',
    routeName: '병점역 → 수원대',
    startName: '병점역 후문',
    endName: '미술대학(조형관)',
    durationText: '약 40분',
    durationSec: 40 * 60,
    direction: 'inbound',
    summary: '교내 정류장 순환',
    notice: '이 시간대는 기존 병점역 등교 셔틀 노선으로 운행합니다.',
    stops: [
      { id: 'byeongjeom-station',              name: '병점역 후문',     type: 'start', lat: BYEONGJEOM.lat, lng: BYEONGJEOM.lng },
      { id: 'humanities-pickup-inbound-0850',  name: '인문대 승차',      type: 'mid',   markerLabel: '인문대 승차', subtext: '병점역 → 수원대 방향', lat: HUM_PICK.lat, lng: HUM_PICK.lng },
      { id: 'campus-sh',                       name: '학생회관 사거리',  type: 'mid',   lat: 37.210081, lng: 126.97701 },
      { id: 'campus-ict',                      name: 'ICT 융합대학',    type: 'mid',   lat: 37.209608, lng: 126.975483 },
      { id: 'campus-music',                    name: '음악대학',         type: 'mid',   lat: 37.209872, lng: 126.972801 },
      { id: 'campus-eng1',                     name: '제1공학관',        type: 'mid',   lat: 37.209096, lng: 126.979252 },
      { id: 'campus-backgate',                 name: '후문',            type: 'mid',   lat: 37.206881, lng: 126.979861 },
      { id: 'campus-art',                      name: '미술대학(조형관)', type: 'end',   lat: 37.207798, lng: 126.977988 },
    ],
    path: [
      BYEONGJEOM,
      HUM_PICK,
      { lat: 37.210081, lng: 126.97701 },
      { lat: 37.209608, lng: 126.975483 },
      { lat: 37.209872, lng: 126.972801 },
      { lat: 37.209096, lng: 126.979252 },
      { lat: 37.206881, lng: 126.979861 },
      { lat: 37.207798, lng: 126.977988 },
    ],
  },
  {
    id: 'byeongjeom_1000',
    label: '10:00',
    fullLabel: '병점역 10:00',
    time: '10:00',
    departureTime: '10:00',
    routeName: '병점역 → 수원대',
    startName: '병점역 후문',
    endName: '인문대 승차',
    durationText: '약 35분',
    durationSec: 35 * 60,
    direction: 'inbound',
    summary: '인문대 승차 경유',
    notice: '병점역에서 수원대학교 방면으로 운행합니다.',
    stops: [
      { id: 'byeongjeom-station',              name: '병점역 후문', type: 'start', lat: BYEONGJEOM.lat, lng: BYEONGJEOM.lng },
      { id: 'humanities-dropoff-inbound-1000', name: '인문대 승차', type: 'end',   markerLabel: '인문대 승차', subtext: '병점역 → 수원대 방향', lat: HUM_PICK.lat, lng: HUM_PICK.lng },
    ],
    path: [
      BYEONGJEOM,
      HUM_PICK,
    ],
  },
  {
    id: 'byeongjeom_1100',
    label: '11:00',
    fullLabel: '병점역 11:00',
    time: '11:00',
    departureTime: '11:00',
    routeName: '병점역 → 수원대',
    startName: '병점역 후문',
    endName: '인문대 승차',
    durationText: '약 35분',
    durationSec: 35 * 60,
    direction: 'inbound',
    summary: '인문대 승차 경유',
    notice: '병점역에서 수원대학교 방면으로 운행합니다.',
    stops: [
      { id: 'byeongjeom-station',              name: '병점역 후문', type: 'start', lat: BYEONGJEOM.lat, lng: BYEONGJEOM.lng },
      { id: 'humanities-dropoff-inbound-1100', name: '인문대 승차', type: 'end',   markerLabel: '인문대 승차', subtext: '병점역 → 수원대 방향', lat: HUM_PICK.lat, lng: HUM_PICK.lng },
    ],
    path: [
      BYEONGJEOM,
      HUM_PICK,
    ],
  },
  // ── outbound ──────────────────────────────────────────────────────────
  {
    id: 'byeongjeom_1640',
    label: '16:40',
    fullLabel: '수원대→병점역 16:40',
    time: '16:40',
    departureTime: '16:40',
    routeName: '수원대 → 병점역',
    startName: SHUTTLE_STOPS['campus-byeongjeom-hagyo'].name,
    endName: '병점역',
    durationText: '약 35분',
    durationSec: 35 * 60,
    direction: 'outbound',
    summary: `${SHUTTLE_STOPS['campus-byeongjeom-hagyo'].name} 출발`,
    notice: `${SHUTTLE_STOPS['campus-byeongjeom-hagyo'].name}에서 병점역 방향으로 출발합니다. 무료 운행.`,
    stops: [
      {
        id: 'campus-byeongjeom-hagyo',
        name: SHUTTLE_STOPS['campus-byeongjeom-hagyo'].name,
        type: 'start',
        markerLabel: '병점역 하교 승차장',
        subtext: '수원대 → 병점역 방향',
        lat: BYEONGJEOM_OUTBOUND_MID.lat,
        lng: BYEONGJEOM_OUTBOUND_MID.lng,
      },
      {
        id: 'byeongjeom-station',
        name: '병점역',
        type: 'end',
        lat: BYEONGJEOM.lat,
        lng: BYEONGJEOM.lng,
      },
    ],
    path: [
      BYEONGJEOM_OUTBOUND_MID,
      BYEONGJEOM,
    ],
  },
]

/** path 위에서 fraction(0~1) 비율의 위치를 보간 */
export function interpolateOnPath(path, fraction) {
  if (!path || path.length < 2) return null
  const clamped = Math.max(0, Math.min(1, fraction))
  if (clamped <= 0) return path[0]
  if (clamped >= 1) return path[path.length - 1]
  const totalSegs = path.length - 1
  const segF = clamped * totalSegs
  const segIdx = Math.floor(segF)
  const within = segF - segIdx
  const p1 = path[Math.min(segIdx, path.length - 1)]
  const p2 = path[Math.min(segIdx + 1, path.length - 1)]
  return {
    lat: p1.lat + (p2.lat - p1.lat) * within,
    lng: p1.lng + (p2.lng - p1.lng) * within,
  }
}
